module.exports = __webpack_public_path__ + "static/media/golfgif.4692e671.gif";